import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import { getCSSColorBg, getCSSColorText } from '~/utilities/getCSS';

const noticeClasses = cva('py-2.5 px-5 font-group-tiny text-center', {
  variants: {
    color: getCSSColorText(),
    background: getCSSColorBg(),
  },
});

export default component$((): JSX.Element => {
  const {
    themeComponents: { footer },
    payloadToSSR: { layout },
  } = useContext(AppDataContext);
  const year = new Date().getFullYear();

  return (
    <p
      class={noticeClasses({
        color: footer.bottomBarTextColor.value,
        background: footer.bottomBarBackgroundColor.value,
      })}
    >
      <span>© {year} </span>
      <a class='underline' href={layout.footer.poweredByLink?.value.url}>
        {layout.footer.poweredByLink?.value.text}
      </a>
      <span> - </span>
      <span>{layout.footer.rightsReservedText?.value}</span>
    </p>
  );
});
